import { render, staticRenderFns } from "./numberGrow.vue?vue&type=template&id=f172b48e"
import script from "./numberGrow.vue?vue&type=script&lang=js"
export * from "./numberGrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports